import React, { useEffect, useState } from "react";
import config from "clientappsetting.json";

import "./FooterStyles.scss";
import { DriverMicrositeFooterLink } from "generated/types/types";
import { ApiUrlResolver } from "utils/ApiUrlResolver";
import { useSelector } from "react-redux";
import { RootState } from "redux/store/store";

interface Props {
    micrositePin: string;
    footerImageBlobGuid: string | null;
    footerStraplineText: string | null;
}

export const Footer: React.FC<Props> = (props: Props) => {
    const [footerLinks, setFooterLinks] = useState<DriverMicrositeFooterLink[]>([]);
    const countryCode = useSelector((state: RootState) => state.country.countryCode);

    useEffect(() => {
        fetch(ApiUrlResolver.getSettingAPIUrl(countryCode) + `/DriverMicrosite/DriverMicrositeFooterLinks/${props.micrositePin}`)
            .then(response => response.json())
            .then((data: DriverMicrositeFooterLink[]) => {
                const links: DriverMicrositeFooterLink[] = [
                    ...data,
                    {
                        linkText: "Cookie Declaration",
                        linkUrl: "cookieDeclaration.html",
                        ordinalNumber: 999,
                    },
                ];
                setFooterLinks(links);
            });
    }, [props.micrositePin]);

    if (!props.footerStraplineText && !props.footerImageBlobGuid && footerLinks.length === 0) {
        return <></>;
    }

    const getRightColWidthCssClass = () => {
        if (footerLinks.length > 0 && props.footerImageBlobGuid && props.footerStraplineText) {
            return "col-7";
        }
        // XOR check on the image and strapline
        if (props.footerImageBlobGuid !== props.footerStraplineText && footerLinks.length > 0) {
            return "col-8";
        }

        if (footerLinks.length > 0 && !props.footerImageBlobGuid && !props.footerStraplineText) {
            return "col-12";
        }

        return "";
    };

    const getLeftColWidthCssClass = () => {
        if (footerLinks.length <= 0) {
            return "col-12";
        }

        if (footerLinks.length > 0 && props.footerImageBlobGuid && props.footerStraplineText) {
            return "col-5";
        }
        // XOR check on the image and strapline
        if (props.footerImageBlobGuid !== props.footerStraplineText && footerLinks.length > 0) {
            return "col-4";
        }

        return "";
    };

    return (
        <div className="footer no-print">
            <div className="spacer"></div>
            <div className="footer-container container">
                <div className="row">
                    <div className={`col-cont ${getLeftColWidthCssClass()}`}>
                        {props.footerImageBlobGuid ? (
                            <div className={"footer-image"}>
                                <img src={`${config.API_URL}/Blob/GetBlobFile/${props.footerImageBlobGuid}`} alt="footer" />
                            </div>
                        ) : (
                            <></>
                        )}
                        {props.footerStraplineText ? <div className="footer-strapline">{props.footerStraplineText}</div> : <></>}
                    </div>
                    <div className={`col-cont ${getRightColWidthCssClass()}`}>
                        <div className="links row">
                            {footerLinks.map((x, index) => (
                                <div key={index} className="link-container col-12 col-md-6 col-xl-auto">
                                    <a target="_blank" href={x.linkUrl} rel="noreferrer">
                                        {x.linkText}
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
